import { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { toggleSidenav } from '../actions';

const REPORT_PATHS = [
  '/report-search',
  '/remake-report',
  '/tip-report',
  '/throughput-report',
];

const Header = ({ authenticated, sidenav, toggleSidenav }) => {
  const [reportOpen, setReportOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { pathname } = useLocation();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setReportOpen(false);
      }
    };

    if (reportOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [reportOpen]);

  const handleReportClick = useCallback((e) => {
    e.preventDefault();
    setReportOpen((prev) => !prev);
  }, []);

  const handleDropdownLinkClick = useCallback(() => {
    setReportOpen(false);
  }, []);

  const renderLinks = useCallback(() => {
    const authedLinks = [
      { link: '/order-list', desc: 'Order' },
      { link: '/delivery-list', desc: 'Delivery' },
      { link: '/remake-list', desc: 'Remake' },
      { link: '/signout', desc: 'Sign Out' },
    ];

    if (authenticated) {
      let key = 1;
      const links = [];

      // Add regular links up to Remake
      authedLinks.slice(0, 3).forEach(({ link, desc }) => {
        links.push(
          <li key={key++} className={pathname === link ? 'active-nav' : ''}>
            <Link to={link}>{desc}</Link>
          </li>,
        );
      });

      // Add Report dropdown
      links.push(
        <li
          key={key++}
          className={`nav-dropdown-wrapper${REPORT_PATHS.includes(pathname) ? ' active-nav' : ''}`}
          ref={dropdownRef}
        >
          <button
            type="button"
            className="nav-dropdown-trigger"
            onClick={handleReportClick}
          >
            Report{' '}
            <i className="material-icons nav-dropdown-icon">arrow_drop_down</i>
          </button>
          {reportOpen && (
            <ul className="nav-dropdown">
              <li>
                <Link to="/report-search" onClick={handleDropdownLinkClick}>
                  Order/Delivery
                </Link>
              </li>
              <li>
                <Link to="/remake-report" onClick={handleDropdownLinkClick}>
                  Remake
                </Link>
              </li>
              <li>
                <Link to="/tip-report" onClick={handleDropdownLinkClick}>
                  Tip
                </Link>
              </li>
              <li>
                <Link to="/throughput-report" onClick={handleDropdownLinkClick}>
                  Throughput
                </Link>
              </li>
            </ul>
          )}
        </li>,
      );

      // Add Sign Out
      links.push(
        <li key={key++}>
          <Link to="/signout">Sign Out</Link>
        </li>,
      );

      return links;
    } else {
      return (
        <li>
          <Link key="0" to="/signin">
            Sign In
          </Link>
        </li>
      );
    }
  }, [
    authenticated,
    reportOpen,
    handleReportClick,
    handleDropdownLinkClick,
    pathname,
  ]);

  const handleToggle = useCallback(
    (e) => {
      e.preventDefault();
      toggleSidenav(!sidenav);
    },
    [sidenav, toggleSidenav],
  );

  return (
    <div>
      <header className="navbar-fixed">
        <nav className="black">
          <div className="nav-wrapper container">
            <Link to="/" className="brand-logo">
              DESOURO
            </Link>
            <a href="#" onClick={handleToggle} className="sidenav-trigger">
              <i className="material-icons">menu</i>
            </a>
            <ul id="nav-mobile" className="right hide-on-med-and-down">
              {renderLinks()}
            </ul>
          </div>
        </nav>
      </header>
    </div>
  );
};

function mapStateToProps(state) {
  return { authenticated: state.auth.authenticated, sidenav: state.sidenav };
}

export default connect(mapStateToProps, { toggleSidenav })(Header);
